module.exports = {
    googlePlayStore: "https://play.google.com/store/apps/details?id=com.whydocumentaries.yesterdaystories&pli=1",
    appStore: "https://apps.apple.com/au/app/yesterday-stories/id1382978257",
};